/* eslint-env es6 */

(function () {
  const script = document.createElement('script');
  
  script.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('charset', 'UTF-8');
  script.setAttribute('data-domain-script', 'f0e2525c-ab2b-4e3a-bef4-3eff3bc818c0-test');
  document.getElementsByTagName('head')[0].appendChild(script);
})();

function reloadOTBanner() {
  let otConsentSdk = document.getElementById('onetrust-consent-sdk');
  if (otConsentSdk) {
    otConsentSdk.remove();
  }

  if (window.OneTrust != null) {
    OneTrust.Init();

    setTimeout(function () {
      OneTrust.LoadBanner();

      let toggleDisplay = document.getElementsByClassName('ot-sdk-show-settings');

      for (const element of toggleDisplay) {
        element.onclick = function (event) {
          event.stopImmediatePropagation();
          window.OneTrust.ToggleInfoDisplay();
        };
      }
    }, 1000);
  }
}
